import styled from 'styled-components';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';

export const TotalFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderColor: theme.colors.neutral[200],
  borderStyle: 'solid',
  borderWidth: '1px 0',
  padding: '12px 24px',
  position: 'sticky',
  bottom: 0,
  background: theme.colors.bg,
  zIndex: 2,
}));
